import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class PrestartProvider {
  baseUrl: any;
  constructor(public http: HttpClient) {
    this.baseUrl = "http://cotest.online/klmr_cabsand/index.php/api"; //  live
  }


  getPrestartList(){
    return new Promise((resolve,reject) => {
      this.http.get(this.baseUrl + '/prestart/get').subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
        console.log("ERER:",err);
      });
    });
  }

}




// WEBPACK FOOTER //
// ./src/providers/prestart/prestart.ts